import {useAxiosAuth} from "@/hooks/useAxiosAuth";
import {useMutation} from "@tanstack/react-query";
import {ApiConfig} from "@/config/api.config.ts";
import {ErrorKey, getErrorKey} from "@/config/apiErrorKeys.ts";
import {AxiosError} from "axios";
import {ProblemDetails} from "@/@types/base.types.ts";

type Props = {
    onSuccess?: () => void;
    onError?: (error: ErrorKey) => void;
}

export const useForgotPasswordApi = ({onSuccess, onError}: Props) => {
    const axiosInstance = useAxiosAuth();

    const {mutateAsync: doGetForgotPasswordLink, isPending: isDoGetForgotPasswordLinkPending} = useMutation({
        mutationFn: async (email: string) => {
            const response = await axiosInstance.post(ApiConfig.queries.auth.forgotPassword.endpoint, {email});
            return response.data;
        },
        onSuccess: () => {
            onSuccess?.();
        },
        onError: (error: AxiosError<ProblemDetails>) => {
            onError?.(getErrorKey(error));
        }
    })

    return {
        doGetForgotPasswordLink,
        isDoGetForgotPasswordLinkPending
    }
}